export enum AlertType {
  Success,
  Error,
  Info,
  Warning
}



// WEBPACK FOOTER //
// C:/Users/rzonsol/WebstormProjects/ammpb2/src/app/alert/alert-type.enum.ts